export default __webpack_public_path__ + "static/media/con_body04.8644b4f6.jpg";